import { render, staticRenderFns } from "./CardM.vue?vue&type=template&id=4564e534&scoped=true&"
import script from "./CardM.vue?vue&type=script&lang=js&"
export * from "./CardM.vue?vue&type=script&lang=js&"
import style0 from "./CardM.vue?vue&type=style&index=0&id=4564e534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564e534",
  null
  
)

export default component.exports